import React from 'react';

const BadgeList = ({ badges = [], maxDisplay = 3 }) => {
  if (!badges || badges.length === 0) return null;

  return (
    <div className="d-flex flex-wrap gap-2 mb-2">
      {badges.slice(0, maxDisplay).map((badge, idx) => (
        <img
          key={badge._id || idx}
          src={badge.iconUrl}
          alt={`Badge: ${badge.name}`}
          title={badge.name}
          style={{
            width: '68px',
            height: '68px',
            borderRadius: '8px',
            border: '1.5px solid #ccc',
            backgroundColor: '#fff',
            objectFit: 'contain',
          }}
        />
      ))}
    </div>
  );
};

export default BadgeList;
